import e, { useState as b } from "react";
import E from "./index171.mjs";
import f from "./index187.mjs";
import t from "./index257.mjs";
import c from "classnames";
import { track as y } from "./index9.mjs";
import { TRACK_EVENT_TYPE as C, TRACK_EVENT as N } from "./index10.mjs";
import { useHotelConfig as T } from "./index93.mjs";
import { getSubscriptionPlanRoot as k } from "./index14.mjs";
import { EmptyImage as x } from "./index258.mjs";
const V = ({ images: i, source: m }) => {
  var s;
  const [o, r] = b(0), { hotelId: g, propertySize: p, propertyType: d, subscriptionPlan: u } = T(), l = () => {
    y(N.CLICK, C.PICTURE_MOTION_CLICKED, {
      hotel_id: g,
      property_type: d,
      property_size: p,
      subscription_plan: k(u),
      source: m
    });
  }, _ = (n) => {
    n.stopPropagation(), l(), r((a) => a + 1);
  }, I = (n) => {
    n.stopPropagation(), l(), r((a) => a - 1);
  };
  return i.length === 0 ? /* @__PURE__ */ e.createElement(x, null) : /* @__PURE__ */ e.createElement(
    "section",
    {
      "data-testid": "images-slider",
      className: t.container,
      "aria-label": I18n.t("booking_engine.accessibility.carousel_image_gallery")
    },
    o > 0 ? /* @__PURE__ */ e.createElement(
      "button",
      {
        onClick: I,
        className: c(t.slide, t["slide--prev"]),
        "data-testid": "slide-prev",
        "aria-label": I18n.t(
          "booking_engine.accessibility.carousel_previous_image"
        ),
        type: "button"
      },
      /* @__PURE__ */ e.createElement(E, null)
    ) : null,
    /* @__PURE__ */ e.createElement("div", { className: t["image-container"] }, /* @__PURE__ */ e.createElement(
      "img",
      {
        src: (s = i[o]) == null ? void 0 : s.url,
        alt: I18n.t("booking_engine.accessibility.image_of_count", {
          current: (o + 1).toString(),
          total: i.length.toString()
        })
      }
    )),
    o < i.length - 1 ? /* @__PURE__ */ e.createElement(
      "button",
      {
        onClick: _,
        className: c(t.slide, t["slide--next"]),
        "data-testid": "slide-next",
        "aria-label": I18n.t(
          "booking_engine.accessibility.carousel_next_image"
        ),
        type: "button"
      },
      /* @__PURE__ */ e.createElement(f, null)
    ) : null,
    /* @__PURE__ */ e.createElement("div", { "data-testid": "image-index", className: t["image-index"] }, o + 1, "/", i.length)
  );
};
export {
  V as ImageSlider
};
